import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionStatus, PopupRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { UserInfo } from './Models/user-info';
import { UserProfile } from './Models/user-profile';
import { ProfileService } from './Services/profile.service';
import { UserService } from './Services/user.service';

//const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent implements OnInit, OnDestroy {
  domain = '';
  title = 'school board policy';
  isIframe = false;
  loginDisplay = false;
  profile : UserProfile;
  profilePnumber : string;
  currentUserInfo : UserInfo;
  userType : string;
  adminUser : boolean = false;

  private readonly _destroying$ = new Subject<void>();

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
                      , private broadcastService: MsalBroadcastService
                      , private authService: MsalService
                      , private profileService: ProfileService
                      , private userService: UserService
                      //, private userInfoModel: UserInfo
                      , private router: Router) { }

  ngOnInit() {
    this.domain = location.hostname;
    //console.log("domain: " + this.domain);
    this.isIframe = window !== window.parent && !window.opener;
    //this.getProfile();
    //this.checkCurrentUserType();

    // this.broadcastService.inProgress$
    // .pipe(
    //   filter((status: InteractionStatus) => status === InteractionStatus.None),
    //   takeUntil(this._destroying$)
    // )
    // .subscribe(() => {
    //   this.setLoginDisplay();
    // });
  }

  login() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
        .subscribe({
          next: (result) => {
            //alert(JSON.stringify(result));
            this.setLoginDisplay();
            //mainWindowRedirectUri: "/schoolboardpolicy";
          },
          error: (error) => console.log(error)
        });
    } 
    else {
      this.authService.loginPopup()
        .subscribe({
          next: (result) => {
            //console.log(result);
            this.setLoginDisplay();
            //mainWindowRedirectUri: "/schoolboardpolicy";
          },
          error: (error) => console.log(error)
        });
    }
  }

  logout() { // Add log out function here
    this.authService.logoutPopup({
      //mainWindowRedirectUri: "/"
      mainWindowRedirectUri: "/schoolboardpolicy"
    });
    localStorage.removeItem('UserInfo');
    localStorage.removeItem('UserADProfile');
  }
  
  setLoginDisplay() {
    //alert("this.authService.instance.getAllAccounts().length: " + this.authService.instance.getAllAccounts().length);
    if (this.authService.instance.getAllAccounts().length > 0) {
      this.profile = this.profileService.getProfile();
      var userPNumber = this.profile.userPrincipalName.substring(0, 9);
      //alert("userPNumber: " + userPNumber);
      this.userService.getCurrentUserInfo_New("/getuserinfo/" + userPNumber).subscribe(
        data => {
          this.currentUserInfo = data as UserInfo;
          this.userType = this.currentUserInfo.userType;
          //alert("current user: " + JSON.stringify(this.currentUserInfo));
        }
      );
    }
    this.userService.setCurrentUserInfo_New(this.currentUserInfo);
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    localStorage.clear();
  }

  getProfile() {
    this.profile = this.profileService.getProfile();
    // return this.profileService.getProfile_Adapter().subscribe(
    //   data => {
    //     this.profile = data;
    //   }
    // );
    //this.checkCurrentUserType();
    // if (this.profile !== undefined) {
    //   this.profilePnumber = this.profile.userPrincipalName.substring(0, 9);
    //   this.userService.setCurrentUserInfo(this.profilePnumber);

    //   //this.userType = this.userInfo[0].UserType;
    //   // if (this.userType !== undefined && this.userType === 'Admin') {
        
    //   // }
    // }
    //this.router.navigate(['/user'], { queryParams : this.profile});
  }

  checkCurrentUserType() {
    this.currentUserInfo = this.userService.getCurrentUserInfo();
    if (this.currentUserInfo !== undefined && this.currentUserInfo !== null && Object.keys(this.currentUserInfo).length > 0) {
      this.profile = this.profileService.getProfile();
      this.profilePnumber = this.profile.userPrincipalName.substring(0, 9);
      if (this.currentUserInfo.userPNumber === this.profilePnumber) {
        this.userType = this.currentUserInfo.userType;
        if (this.currentUserInfo.active && this.currentUserInfo.userType === 'Admin') {
          //this.adminUser = true;
        }
      }
      // this.profileService.getProfile_Adapter().subscribe(
      //   data => {
      //     this.profile = data;
      //     this.profilePnumber = this.profile.userPrincipalName.substring(0, 9);
      //     if (this.currentUserInfo.userPNumber === this.profilePnumber) {
      //       if (this.currentUserInfo.active && this.currentUserInfo.userType === 'Admin') {
      //         this.adminUser = true;
      //       }
      //     }
      //   }
      // );
    }
    else {
      //this.adminUser = this.userService.adminUser;
    }
  }
  // setProfileState() {
  //   this.profileService.getProfile();
  // }
}
